import React from 'react'
import { PropertyGrid, TextInput } from '@leverege/ui-elements'
import { useValueChange } from '@leverege/ui-hooks'

import Model from './ClientIdModel'

export default function ClientIdEditor( props ) {
  const { value } = props

  const onChange = useValueChange( Model, props )

  return (
    <PropertyGrid variant="itemEditor">
      <PropertyGrid.Item label="Alias" stretch>
        <TextInput
          onChange={onChange}
          eventData="setAlias"
          value={Model.getAlias( value )} />
      </PropertyGrid.Item>
      <PropertyGrid.Item label="Authorization URI" stretch>
        <TextInput
          onChange={onChange}
          eventData="setAuthorizationUri"
          value={Model.getAuthorizationUri( value )} />
      </PropertyGrid.Item>
    </PropertyGrid>
  )
}
